import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import {
  AllGameVo,
  GameSeriesInfoVo,
  RobloxValueListRequest,
  RobloxValueListVO,
  RobloxValueGameOptions,
  RobloxValueGameListVO,
  RobloxValueGameList
} from './type';

/**
 * 主站首页查询ALL GAME SERVICE
  GET /product/urlMapping/game-service/getAllEntity
  接口ID：257336691
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-257336691
 */
export const getAllGameServiceList = (): AxiosPromise<AllGameVo> => {
  return request({
    url: '/product/urlMapping/game-service/getAllEntity',
    method: 'get'
  });
};
// 查询h5地址对应的游戏集合
export const queryGameSeries = (params: { series: string | number }): AxiosPromise<GameSeriesInfoVo> => {
  return request({
    url: '/product/urlMapping/game-service/queryGameSeries',
    method: 'get',
    params
  });
};

// 获取分类 Roblox Games
export const robloxValueCategories = (): AxiosPromise<{ categoryId?: string; category?: string }[]> => {
  return request({
    url: '/statistic/robloxValue/categories',
    method: 'get'
  });
};

// 获取筛选项 Roblox Games
export const robloxValueOptions = (
  categoryId: string
): AxiosPromise<{ years?: string[]; events?: string[]; stabilises?: string[] }> => {
  return request({
    url: '/statistic/robloxValue/options',
    method: 'get',
    params: { categoryId }
  });
};

// 获取列表 Roblox Games
export const robloxValueList = (query: RobloxValueListRequest): AxiosPromise<RobloxValueListVO[]> => {
  return request({
    url: '/statistic/robloxValue/list',
    method: 'get',
    params: query
  });
};

// 获取筛选项-通用
export const robloxValueGameOptions = (game: string): AxiosPromise<RobloxValueGameOptions> => {
  return request({
    url: '/statistic/robloxValue/game/options',
    method: 'get',
    params: { game }
  });
};

// 获取列表-通用
export const robloxValueGameList = (query: RobloxValueGameListVO): AxiosPromise<RobloxValueGameList[]> => {
  return request({
    url: '/statistic/robloxValue/game/list',
    method: 'get',
    params: query
  });
};
